import { PageBreadcrumbs } from 'src/components'
import { useLocales } from 'src/locales'

import { ConsumablesCard } from '../components'

export const ConsumablesPage = () => {
  const { t } = useLocales()

  return (
    <PageBreadcrumbs
      items={[
        {
          title: t('menu.medicines_register')
        },
        {
          title: t('medicine_register.consumables.title')
        }
      ]}
      title={t('medicine_register.consumables.title')}
    >
      <ConsumablesCard />
    </PageBreadcrumbs>
  )
}
